<template>
    <ul class="beverage-container">
        <li
            class="beverage-item"
            :class="{ active: defaultCup === item.Name }"
            v-for="(item, index) in beverage"
            @click="setDefaultCup(item)"
            :key="index"
        >
            <div class="image-wrapper">
                <img
                    class="item-image"
                    :src=item.FullImageUrl
                    alt=""
                />
            </div>
            <div v-if="item.Name.length > 25" class="item-name">{{ item.Name.substring(0, 25) }} ...</div>
            <div v-else class="item-name">{{ item.Name }}</div>
        </li>
    </ul>
</template>

<script>
export default {
    name: "BeverageList",
    props: {
        beverage: Array
    },
    data() {
        return {
            defaultCup: "",
        };
    },
    created() {
        if (this.beverage.length > 0) {
            this.setDefaultCup(this.beverage[0]);
        }
    },
    methods: {
        setDefaultCup(cup) {
            this.defaultCup = cup.Name;
            this.$emit("setDefaultCup", cup);
        },
    }
};
</script>

<style lang="scss" scoped>
.beverage-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .beverage-item {
        background-color: rgba(255, 255, 255, 0.2);
        width: 45%;
        border-radius: 15px;
        padding: 0px 6px 15px;
        margin-top: 75px;
        &.active {
            opacity: 1;
            background-color: #a7907b;
        }
        .image-wrapper {
            display: flex;
            width: 100%;
            justify-content: center;
            .item-image {
                width: 95px;
                margin-top: -65px;
            }
        }
        .item-name {
            text-align: center;
            font-size: 16px;
            color: #fff;
        }
    }
}
</style>
